
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { location } from '@constants/location';
import { retailer } from '@constants/retailer';
import { BffApiService } from '@shared/bff-api.service';
import Dropzone from 'dropzone';
import { errorGeneral, SnackBarService, successGeneral } from 'src/app/shared/service/snack-bar.service';
import { UserService } from 'src/app/shared/service/user.service';

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrl: './profil.component.scss',
  imports: [ReactiveFormsModule],
})
export class ProfilComponent implements OnInit {
  cashProgrammForm: FormGroup;
  contactInfos: FormGroup;
  publicInfos: FormGroup;
  editCashInfos: boolean = false;
  editPersonnalInfos: boolean = false;
  cashProgram: any[] = [];
  user = retailer;
  isChangePublicInfos: boolean = false;
  myDropzone: Dropzone | undefined;

  constructor(
    private bff: BffApiService,
    private fb: FormBuilder,
    private snack: SnackBarService,
    private userService: UserService
  ) {
    this.cashProgrammForm = this.fb.group({
      name: [null, Validators.required],
      url: [null, Validators.required],
      secret: [null, Validators.required],
    });
    this.contactInfos = this.fb.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      phone: [null, Validators.required],
    });
    this.publicInfos = this.fb.group({
      name: [null, Validators.required],
      street: [null, Validators.required],
      street_number: [null, Validators.required],
      zip: [null, Validators.required],
      city: [null, Validators.required],
      state: [null, Validators.required],
      description: [null, Validators.required],
      logo: [null, Validators.required],
    });
    this.bff.getSecret().subscribe((data) => {
      if (data.length == 0) {
        return;
      }
      this.cashProgram = data;
    });

    this.userService.currentUser.subscribe((user: any) => (this.user = user));
  }

  toggleEditCashInfos() {
    this.editCashInfos = !this.editCashInfos;
  }
  toggleEditPersonalInfos() {
    this.editPersonnalInfos = !this.editPersonnalInfos;
  }

  sendCashProgramChanges(form: FormGroup) {
    if (form.invalid) {
      this.snack.snack(errorGeneral);
      return;
    }
    this.bff.postSecret(form.value).subscribe((data) => {
      this.toggleEditCashInfos();
      this.cashProgram.push({ url: form.value.url, name: form.value.name });
      this.snack.snack(successGeneral);
    });
  }
  sendProfileChanges(form: FormGroup) {
    console.log(form.value);
    if (form.invalid) {
      this.snack.snack(errorGeneral);
      return;
    }
    this.bff.putProfileInfo(form.value).subscribe((data) => {
      this.snack.snack(successGeneral);
    });
  }

  changePassword: FormGroup = this.fb.group({
    now_password: [null, Validators.required],
    password: [null, Validators.required],
    repeat_password: [null, Validators.required],
  });

  isChangePWD: boolean = false;

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.changePassword = this.fb.group({
      email: [null, Validators.required],
      password: [null, Validators.required],
      password_confirmation: [null, Validators.required],
    });
  }
  submit() {
    // if (this.changePassword.invalid) {
    //   this.snack.open('Le formulaire est faux veuillez verifier les informations entrées')
    //   return
    // }
    // this.userService.changePWD(this.changePassword.value)
  }

  togglePWD() {
    this.isChangePWD = !this.isChangePWD;
  }

  protected readonly location = location;

  updPublicInfos() {
    //TODO
  }

  // Delay function that returns a promise
  delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  togglePublicInfos() {
    this.isChangePublicInfos = !this.isChangePublicInfos;

    if (this.isChangePublicInfos) {
      // If Dropzone version is older than 6.0.0, disable autoDiscover
      Dropzone.autoDiscover = false;

      (async () => {
        // Wait for 0.1 seconds, form the html beeing there
        await this.delay(50);
        // Initialize Dropzone after the delay
        const myDropzone = new Dropzone('#my-form', { uploadMultiple: false, acceptedFiles: '.jpeg,.jpg,.png' });
        // Add an event listener for the 'addedfile' event
        myDropzone.on('addedfile', (file) => {
          console.log(file);
          // You can add additional logic here, like updating the UI with file info
          this.bff.postLogo(file.dataURL).subscribe((data: any) => console.log(data));
        });
      })();
    }
  }
}
